import React, { useState } from 'react';
import { Card, CardBody, CardTitle, Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';

import {
  surveysCount,
  completedSurveysCount,
  partialSurveysCount,
  percentageEngagementRate,
  percentageCompletionRate,
} from '../../selectors/survey';

import ApexRadial from '../../components/Common/ApexRadial';
import { Spinner } from 'react-activity';
import colors from '../../components/CommonStyle/colors';

const SurveyInsights = (props) => {
  const surveys = useSelector(surveysCount);
  const completedSurveys = useSelector(completedSurveysCount);
  const partialSurveys = useSelector(partialSurveysCount);
  const engagementRate = useSelector(percentageEngagementRate);
  const completionRate = useSelector(percentageCompletionRate);

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Survey Insights</CardTitle>
        <Row>
          <Col>
            <div className="font-size-16 text-muted mb-3">
              Total Surveys:{' '}
              <span className="font-size-22 text-dark mr-2 font-weight-bold">
                {!props.loading ? (
                  surveys
                ) : (
                  <Spinner
                    color={colors.dark}
                    size={16}
                    speed={1}
                    animating={true}
                  />
                )}
              </span>
            </div>
            <div className="font-size-14 text-muted mb-2">
              <span className="font-size-16 text-success mr-2 font-weight-bold">
                {!props.loading ? (
                  completedSurveys
                ) : (
                  <Spinner
                    color={colors.success}
                    size={14}
                    speed={1}
                    animating={true}
                  />
                )}
              </span>
              completed
            </div>
            <div className="font-size-14 text-muted mb-2">
              <span className="font-size-16 text-warning mr-2 font-weight-bold">
                {!props.loading ? (
                  partialSurveys
                ) : (
                  <Spinner
                    color={colors.warning}
                    size={14}
                    speed={1}
                    animating={true}
                  />
                )}
              </span>
              partial submitted
            </div>
          </Col>
          <Col>
            <ApexRadial
              colors={[colors.primary]}
              labels={['Engagement rate']}
              series={[
                isFinite(engagementRate) ? engagementRate.toFixed(0) : 0,
              ]}
            />
          </Col>
          <Col>
            <ApexRadial
              colors={[colors.success]}
              labels={['Completion rate']}
              series={[
                isFinite(completionRate) ? completionRate.toFixed(0) : 0,
              ]}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default SurveyInsights;
